module.exports = __webpack_public_path__ + "static/speed-hero@2x-f92c5725622b8923f4054a60a1179cf4.webp";